var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn--white btn--text-small",on:{"click":_vm.goBack}},[_vm._v(" Zurück ")])}
var staticRenderFns = []

export { render, staticRenderFns }